// Sales > Quotes (GES-28 run 3): pure model — filter state, request query, client sort, duplicate prefill.
// No money arithmetic: totals come from the server as exact text; sorting only COMPARES values.
export const STATUSES = ['all', 'open', 'converted', 'closed'];   // 'all' = every status in one list
export const CLOSE_REASONS = ['on_hold', 'declined', 'expired', 'other'];
export const QUICK = [['stale', '#b14a30'], ['no_target', '#c47d10'], ['this_month', '#2d6a4f']];   // [key, colour], OR-composed
export const EMPTY = { q: '', partner_ids: [], item_ids: [], reasons: [], date_from: '', date_to: '', quick: [] };

export const toggleIn = (arr, v) => (arr.includes(v) ? arr.filter(x => x !== v) : [...arr, v]);
export const activeCount = f => ['partner_ids', 'item_ids', 'reasons', 'quick'].filter(k => f[k].length).length
  + (f.q.trim() ? 1 : 0) + (f.date_from || f.date_to ? 1 : 0);

// GET /sales/quotes query string for a status tab + filters (empty values omitted).
export function quoteQuery(status, f) {
  const p = new URLSearchParams({ status });
  for (const k of ['partner_ids', 'item_ids', 'reasons', 'quick']) if (f[k].length) p.set(k, f[k].join(','));
  for (const k of ['q', 'date_from', 'date_to']) if (String(f[k] || '').trim()) p.set(k, String(f[k]).trim());
  return p.toString();
}

// Client-side sort of the server's (already filtered) rows. Click cycles asc -> desc -> natural (date desc).
const SORT_KEYS = { date: r => r.date || '', customer: r => String(r.partner_name || '').toLowerCase(), op: r => r.operation_id,
  lines: r => Number(r.line_count) || 0, total: r => Number(r.total_value) || 0, target: r => r.expected_delivery_date || '',
  status_at: r => r.closed_at || r.converted_at || '', order_date: r => r.order_date || '', status: r => r.status || '' };
export const SORTABLE = Object.keys(SORT_KEYS);
export const nextSort = (sort, key) => (!sort || sort.key !== key ? { key, dir: 'asc' } : sort.dir === 'asc' ? { key, dir: 'desc' } : null);
export function sortRows(rows, sort) {
  if (!sort || !SORT_KEYS[sort.key]) return rows;
  const get = SORT_KEYS[sort.key]; const m = sort.dir === 'desc' ? -1 : 1;
  return [...rows].sort((a, b) => { const x = get(a), y = get(b); return (x < y ? -1 : x > y ? 1 : 0) * m || String(a.operation_id).localeCompare(String(b.operation_id)); });
}

// Duplicate: the quote's lines become a NEW quote dated today through the normal create path. A line whose item
// is no longer sellable is KEPT (never dropped) and flagged so the drawer blocks the save until it is fixed.
export function duplicateWarnings(quote, sellableIds) {
  const ok = new Set(sellableIds);
  return (quote.lines || []).map((l, i) => (ok.has(l.item_id) ? null : { line: i + 1, item_id: l.item_id, item_name: l.item_name || l.item_id })).filter(Boolean);
}

// The audit row stores 'quote · 2026-10-06 · 1 line(s) · total 63000.00' as TEXT; split it so the drawer can show it
// through Settings > Formatting (null when the text is not that shape: the caller then shows it as-is).
export function parseQuoteSummary(text) {
  const m = /^quote · (\d{4}-\d{2}-\d{2}) · (\d+) line\(s\) · total (-?\d+(?:\.\d+)?)$/.exec(String(text || '').trim());
  return m ? { date: m[1], lines: Number(m[2]), total: m[3] } : null;
}
